import {
  $applyNodeReplacement,
  DOMExportOutput,
  EditorConfig,
  LexicalNode,
  NodeKey,
  SerializedTextNode,
  TextNode
} from "lexical"

type Type = "dynamic-tag"

export type SerializedDynamicTagNode = SerializedTextNode & { type: Type }

export class DynamicTagNode extends TextNode {
  __className = "editor-dynamic-tag"
  __emptyAtt = "data-empty"

  static getType(): Type {
    return "dynamic-tag"
  }

  static clone(node: DynamicTagNode): DynamicTagNode {
    return new DynamicTagNode(node.__text, node.__key)
  }

  constructor(text: string, key?: NodeKey) {
    super(text, key)
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config)

    dom.className = this.__className

    const textAfterBraces = this.__text.slice(2)

    if (textAfterBraces === "") dom.setAttribute(this.__emptyAtt, "true")

    return dom
  }

  updateDOM(
    _prevNode: TextNode,
    dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    const textAfterBraces = this.__text.slice(2)

    if (textAfterBraces === "") dom.setAttribute(this.__emptyAtt, "true")
    else {
      dom.removeAttribute(this.__emptyAtt)
    }

    return true
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement("span")

    element.textContent = this.__text

    return { element }
  }

  static importJSON(serializedNode: SerializedDynamicTagNode): DynamicTagNode {
    const node = $createDynamicTagNode(serializedNode.text)

    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setMode(serializedNode.mode)
    node.setStyle(serializedNode.style)

    return node
  }

  exportJSON(): SerializedDynamicTagNode {
    return {
      ...super.exportJSON(),
      type: "dynamic-tag"
    }
  }

  canInsertTextBefore(): boolean {
    return false
  }

  canInsertTextAfter(): boolean {
    return true
  }

  isTextEntity(): boolean {
    return true
  }
}

export function $createDynamicTagNode(text: string): DynamicTagNode {
  return $applyNodeReplacement(new DynamicTagNode(text))
}

export function $isDynamicTagNode(
  node: LexicalNode | null | undefined
): node is DynamicTagNode {
  return node instanceof DynamicTagNode
}
